import React from "react";


const Section4 = ({url}) => {
  return (
    <section className="home-section-4">
  <div className="container ">

    {/* Heading */}
    <div className="text-center section-header">
      <h2>
        How Traditional Hiring <br />
        <span>Is Broken</span>
      </h2>
    </div>

    <div className="row d-flex align-items-center justify-content-center overflow-hidden">

      <div className="col-lg-3 col-md-6 col-sm-6 col-6 pain-col" data-aos="fade-up" data-aos-duration="800" data-aos-delay="0">
        <div className="pain-card">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-4/1.png`} alt="Manual Resume Screening" />
          </div>
          <p>Manual Resume Screening Wastes 40+ Hours/Week</p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 col-sm-6 col-6 pain-col" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
        <div className="pain-card">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-4/2.png`} alt="Interview Scheduling Chaos" />
          </div>
          <p>Interview Scheduling Chaos Delays Hiring by Weeks</p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 col-sm-6 col-6 pain-col" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
        <div className="pain-card">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-4/3.png`} alt="Inconsistent Evaluation" />
          </div>
          <p>Inconsistent Evaluation Leads to Costly Mis-Hires</p>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 col-sm-6 col-6 pain-col" data-aos="fade-up" data-aos-duration="800" data-aos-delay="300">
        <div className="pain-card">
          <div className="icon-box">
            <img src={`${url}images/intelihire/sec-4/4.png`} alt="Bleeding Budget" />
          </div>
          <p>Bleeding Your Budget and Losing Top Talent</p>
        </div>
      </div>

    </div>
  </div>
</section>
  );
};

export default Section4;
